<button type="button" class="btn btn-info" (click)="onResetButtonClicked()" [ladda]="isBusy" [disabled]="isDisabled">
    <i class="fa-solid fa-rotate-left"></i>
</button>
